const init = () => {

  if (document.querySelector(`[data-nav-toggle]`)) {

    document.querySelector(`[data-nav-toggle]`).addEventListener(`click`, e => {
        e.preventDefault()
        document.body.classList.toggle(`is-nav-active`)
    })
  
  }

}

export default {
  init
}
